export default __webpack_public_path__ + "static/media/image-1-m.3e91dacb.webp";